import Logger from '@core/util/universal-logger';
import PageApp from 'pageApp';
import AddToRegistryController from '../add-to-registry/AddToRegistryController';
import {
  Actions,
  ApplicationMessages,
} from '../util/Constants';
import { getUnselectedTraits } from '../util/ProductModelParser';

export function onAddToRegistryClick(ctaData) {
  const viewStateProductModel = ctaData.productModel.get('viewState');
  const { selectedUpcItem } = ctaData.productModel.get('viewState').detail;
  const isOnlineAvailable = selectedUpcItem && selectedUpcItem.availability.available;
  const addToRegistryController = new AddToRegistryController(ctaData);

  if (!isOnlineAvailable) {
    const unselectedTraits = getUnselectedTraits(viewStateProductModel);
    if (unselectedTraits.length) {
      PageApp.channel.trigger(`${Actions.product.ctaNotification.error}:${ctaData.eventId}`, ApplicationMessages.Atrbopsavailability(unselectedTraits.join('/')));
      return;
    }
    PageApp.channel.trigger(`${Actions.product.ctaNotification.error}:${ctaData.eventId}`, ApplicationMessages.availabilityIssueAtr);
    return;
  }
  addToRegistryController.fireAddToRegistryCall();
}

export function onAddToRegistrySuccess({
  responseData,
  productModel,
}) {
  import(/* webpackChunkName: 'add-to-registry-interstitial' */ '@component/add-to-registry-interstitial')
    .then(({ default: AddToRegistryInterstitial }) => {
      // eslint-disable-next-line no-new
      new AddToRegistryInterstitial({
        data: responseData,
        assetsHost: productModel.get('product').urlTemplate.product,
      });
    })
    .catch(Logger.error);
}



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/listeners/AddToRegistryListeners.js